export default {
    meta: {
        title: '消息'
    }
};
